import Compressor from 'compressorjs';

export const IMAGE_COMPRESS_CONFIG = {
  quality: 0.8,
  maxWidth: 1400,
  maxHeight: 1400,
};

export default function (file, options) {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      ...IMAGE_COMPRESS_CONFIG,
      ...options,
      success: resolve,
      error: reject,
    });
  });
}
